module.exports = __webpack_public_path__ + "static/media/orange.861cac00.svg";